import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Container } from 'Components/core';
import { layout, colors } from 'Constants';

const NavItem = styled.span`
  position: relative;
  color: ${colors.text};
  transition: 0.2s color;
  cursor: pointer;

  :hover {
    color: ${colors.accent};
  }

  > .dropdown {
    display: none;
  }

  :hover > .dropdown {
    display: flex;
  }
`;

const LinkCustom = styled(Link)`
  text-decoration: none;
`;

const NavDropdown = styled.div`
  position: absolute;
  top: 100%;
  z-index: 10;
  display: flex;
  flex-direction: column;
  width: 350px;
  padding: 16px;
  background: ${colors.background};
  box-shadow: 0 0 10px 0px #aaa;

  > * {
    padding: 8px 4px;
  }
`;

const HamburgerDropdown = styled(NavDropdown)`
  top: calc(100% + 5px);
  width: 100vw;
  left: -16px;
  right: 16px;
  margin-left: 0 !important;
  display: none;

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    display: flex;
  }
`;

const SubCard = styled(Container)`
  padding: 8px;
  background: ${colors.backgroundAlt};
  > * {
    padding: 8px 4px;
    margin-left: 16px;
  }
`;

// TODO: URL for Logo?
// FIXME: coBrandUrl
export default props => {
  const state = props.state;

  const NavLink = innerProps => (
    <LinkCustom to={`${innerProps.to}${location.search}`} onClick={() => props.closeHamburger()}>
      <NavItem>{innerProps.children}</NavItem>
    </LinkCustom>
  );

  return (
    <HamburgerDropdown style={props.style}>
      <NavLink to="/">Home</NavLink>
      <SubCard column>
        <span style={{ marginLeft: '8px', position: 'relative' }}>
          Benefits
          <svg className="triangle" height="20" width="20">
            <polygon points="0,0 10,10 20,0" />
          </svg>
        </span>
        {state.includeMedical && (
          <NavLink to="/benefits/medical">Medical Benefits</NavLink>
        )}
        {state.includePharmacy && (
          <NavLink to="/benefits/pharmacy">Pharmacy Benefits</NavLink>
        )}
        {state.includeDental && (
          <NavLink to="/benefits/dental">Dental Benefits</NavLink>
        )}
        {state.includeVision && (
          <NavLink to="/benefits/vision">Vision Benefits</NavLink>
        )}
        {state.includeLifeDisability && (
          <NavLink to="/benefits/life-disability">Life and Disability</NavLink>
        )}
        {state.includeVoluntary && (
          <NavLink to="/benefits/voluntary">
            Voluntary Supplemental Health Benefits
          </NavLink>
        )}
        <NavLink to="/benefits/how-plan-works">
        Understanding Healthcare Terms
        </NavLink>
        {state.includeMoreEnrollmentMaterials && (
                    <NavLink to="/benefits/more-materials">
                    More Enrollment Materials
                  </NavLink>
                  )}  
                    {state.includeBenefitDetails && (
                    <NavLink to="/benefits/benefit-details">
                    Benefit Details
                  </NavLink>
                  )}  
                    {state.vaInOut && (
                    <NavLink  to="/benefits/vaInOut">
                  The Ins and Outs of Coverage
                    </NavLink>
                  )} 
      </SubCard>
      <NavLink to="/where-to-get-care">Where To Get Care</NavLink>
      <NavLink to="/wellness-resources">Wellness Resources</NavLink>
    </HamburgerDropdown>
  );
};
